import { getIsNullish } from '../../jsUtils';
import { getRoundedNumber } from '../getRoundedNumber/getRoundedNumber';

export const getRoundedNumberOrDash = (number: number | string | undefined | null) => {
  const isNumberNotExist = getIsNullish(number);

  return isNumberNotExist ? '—' : getRoundedNumber(number, 1);
};
